<script setup>
import { computed } from 'vue';
import { cva } from 'class-variance-authority';

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

const inputClass = computed(() =>
  cva(
    'w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 shadow-card outline-none ring-0 transition placeholder:text-slate-400 focus:border-green-light focus:ring-4 focus:ring-green-light/20',
    {
      variants: {
        tone: {
          default: 'border-slate-200',
        },
      },
    }
  )({ tone: 'default' })
);

const value = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
});
</script>

<template>
  <div class="w-full">
    <label class="sr-only">Pretraga</label>
    <input
      v-model="value"
      :placeholder="props.placeholder"
      type="search"
      :class="inputClass"
    />
  </div>
</template>

